import Reflux from "reflux";

var ClientActions = Reflux.createActions([
	"loadSummary",
	"loadSummaryCompleted",
	"loadSummaryFailed",
	"new",
	"newCompleted",
	"newFailed",
	"load",
	"loadCompleted",
	"loadFailed",
	"loadSubcollection",
	"save",
	"saveCompleted",
	"saveFailed",
	"delete",
	"deleteCompleted",
	"deleteFailed",
	"getSingle",
	"setField",
	"add",
	"remove",
	"upload",
	"uploadCompleted",
	"uploadFailed",
	"checkIntegration",
	"checkIntegrationCompleted",
	"checkIntegrationFailed",
	"removeIntegration",
	"removeIntegrationCompleted",
	"removeIntegrationFailed",
	"toggleActive",
	"toggleActiveCompleted",
	"toggleActiveFailed",
	"runIntegrationActions",
	"addAgent",
	"removeAgent",
	"ticketSourceSectionRefresh",
	"ticketSourceSectionRefreshCompleted",
	"ticketSourceSectionRefreshFailed",
	"addZendeskUserGroup",
	"getFrontDownload",
	"getFrontDownloadCompleted",
	"runAnalytics",
	"runAnalyticsCompleted",
	"refreshExamples",
	"exportTickets",
	"saveTags",
	"groupChange",
	"unsubscribe",
	"close",
	"update",
	"get",
	"error"
]);

export default ClientActions;
